<div>
  <div class="mb-4">
    <y42-function-editor
      class="w-full"
      [allowedOutputTypes]="allowedOutputTypes"
      [showDefaultInfo]="true"
      [errorInfoHeight]="'80px'"
      [inputCode]="formGroup.controls.low_code_string.value"
      [sourceColumns]="state.sourceColumns"
      (editorValueChanged)="editorValueChanged($event)"
      [showAggregateFunctions]="true"
      (validity)="editorValidityChanged($event)"
    >
    </y42-function-editor>
  </div>

  <y42-threshold-form-part
    [failedByConditionControl]="thresholdFormArguments.rowsFailedByConditionControl"
    [failedConditionControl]="thresholdFormArguments.rowsFailedConditionControl"
  ></y42-threshold-form-part>
</div>
